import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavbarComponent } from '../../navbar/navbar.component';
import { FooterComponent } from '../../footer/footer.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  standalone: true,
  selector: 'app-main-shell',
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    FooterComponent,
    ProgressSpinnerModule,
    ToastModule,
  ],
  templateUrl: './main-shell.component.html',
  providers: [MessageService],
})
export class MainShellComponent implements OnInit {
  rutaInicial = '/';
  isLoading = false;
  isVisible = true;
  hideFooter = false;

  constructor(
    private _cd: ChangeDetectorRef,
    private _router: Router
  ) {}

  ngAfterViewInit(): void {
    this._cd.detectChanges();
  }

  ngOnInit(): void {
    this._router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.hideFooter = e.urlAfterRedirects.includes('/formulario/');
      });

    this.hideFooter = this._router.url.includes('/formulario/');
  }
}
